import { Button } from "antd"
import styles from "./ButtonGreenOriginal.module.css"

const ButtonGreenOriginal = ({namaBtn, onClick, custom}) => {
  return (
    <Button size="large" className={styles.button} style={custom} onClick={onClick}>
      {namaBtn}
    </Button>
  )
}
export default ButtonGreenOriginal